import React from 'react'
import { Link } from 'react-router-dom'

const CustomerName = ({ row, assignedLender }) => {
    return (

        <>
        { assignedLender == 16 ?
            <Link
            to={`/portfolio/collections/details/${row?.cl_lead_id}`}
            >
                {row?.cust_name}
            </Link>
            : row?.cust_name
        }
        </>


        
    )
}

export default CustomerName
